import { render } from "./ShoppingList.vue?vue&type=template&id=f14dd14a&scoped=true&ts=true"
import script from "./ShoppingList.vue?vue&type=script&lang=ts"
export * from "./ShoppingList.vue?vue&type=script&lang=ts"

import "./ShoppingList.vue?vue&type=style&index=0&id=f14dd14a&lang=scss&scoped=true"

import exportComponent from "/Users/tobias/Projects/MontyBuy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f14dd14a"]])

export default __exports__